import React from 'react';
import StoreMoviments from '../components/StoreMoviments';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const StoreMovimentsPage = () => {
  return (
    <div className="content-wrapper">
      <h3>Estoque Registro de Movimentos</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>
          <Link to="/">Início</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Estoque</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col xs={0} sm={0} md={24}>
          <StoreMoviments />
        </Col>
        <Col xs={24} sm={24} md={0}>
          <StoreMoviments />
        </Col>
      </Row>
    </div>
  );
};

export default StoreMovimentsPage;
